export enum FieldTypeEnum {
  Texto = 2,
  Data = 3,
  Numerico = 4,
  Booleano = 5,
  Decimal = 6,
  ListaEnum = 7,
  Anexo = 8,
  ListaRelacionamento = 9,
  CNPJ = 10,
  CPF = 11,
  TextoMultiplasLinhas = 12,
  Email = 13,
  Telefone = 14,
  Celular = 15,
  URL = 16,
  Hora = 17,
  UptimeTempoAtividade = 19
}
